<div id="dds__msthd-overlay" class="dds__msthd-overlay"></div>  
<div class="dds__msthd" data-toggle="dds__msthd">
  <nav class="dds__navbar dds__msthd-navbar-top">
    <div class="dds__msthd-top dds__container dds__no-gutters">
      <div class="dds__row dds__no-gutter">
        <div class="dds__msthd-top-ctnr">
          <div class="dds__msthd-icon-ctnr dds__msthd-logo">
            <div class="dds__msthd-icon-ctnr dds__msthd-logo dds__vertical-divider-right" style="height: 40px;" > 
              <a class="dds__icons dds__msthd-dell-icon" href="//www.dell.com" tabindex="0" aria-label="Dell"></a>
            </div>
          </div>
        </div>
        <div class="dds__msthd-top-ctnr">
          <div>
            <a href="/" style="color: white;"><h5 class="dds__h5  dds__pl-2 dds__pt-2">Agile File Attachment Utility</h5></a>
          </div>
        </div>
       
        
        <div class="dds__msthd-top-right-ctnr dds__d-flex">
          <div *ngIf="!isLoading" class="dds__msthd-top-ctnr">
              <button class="dds__msthd-icon-ctnr"  aria-label="Sign in" aria-haspopup="true" aria-expanded="false">
              <svg focusable="false">
                  <use xlink:href="#dds__user"/>
              </svg>
              <span class="dds__badge dds__badge-success" >
                <i class="dds__icons dds__check"></i>
              </span>
              <span class="dds__msthd-label dds__text-truncate">Welcome, {{userId}}</span>
            </button>
            <div id="msthd-signout-ctnr" class="dds__msthd-ctnr" role="menu">
              <div class="dds__col-sm-12 dds__col-md-12 dds__col-lg-12">
                <h5>
                    <a href="//www.dell.com/en-us/gc/myaccount?~ck=mn">Account Settings</a>
                </h5>
                <hr class="dds__dropdown-divider">
                <h5>
                    <a href="//www.dell.com/support/orders?~ck=mn">Order Status</a>
                </h5>
                <hr class="dds__dropdown-divider">
                <h5>
                    <a href="//dfs.dell.com/pages/dfshomepage.aspx?~ck=mn">Dell Financial Services</a>
                </h5>
                <hr class="dds__dropdown-divider">
                <h5>
                    <a href="//www.dell.com/en-us/shop/dell-rewards-program/cp/dell-rewards-program?~ck=mn">Dell Rewards</a>
                </h5>
                <hr class="dds__dropdown-divider">
                <h5>
                    <a href="//www.dell.com/identity/global/login/75814991-4252-4cc4-a977-670cc21309a7?~ck=mn">Premier Sign In</a>
                </h5>
                <hr class="dds__dropdown-divider">
                <h5>
                    <a href="//www.dell.com/content/public/xdbredirect.aspx?link=global:nav:partnerprogram:signin&amp;~ck=mn">Partner Program Sign In</a>
                </h5>
                <div class="dds__row dds__no-gutters">
                    <div class="dds__col-sm-12">
                        <a class="dds__btn dds__btn-secondary dds__btn-block dds__mt-2" href="/en-us/security/authentication/signoutreturntoreferrer?~ck=mn">Sign Out</a>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div class="dds__msthd-top-ctnr dds__msthd-hidden">
            <button class="dds__msthd-icon-ctnr" data-toggle="dds__msthd-offcanvas" data-target="msthd-off-canvas-menu" aria-label="Menu" aria-haspopup="true" aria-expanded="false">
              <svg focusable="false">
                  <use xlink:href="#dds__menu-closed"></use>
              </svg>
              <span class="dds__msthd-label dds__text-truncate">Menu</span>
            </button>
            <aside id="msthd-off-canvas-menu" class="dds__msthd-offcanvas-menu" hidden>
                <ul role="menu">
                    <li class="dds__msthd-offcanvas-tier-1" role="menuitem"></li>
                    <button class="dds__msthd-offcanvas-nav-item dds__collapsed" data-toggle="dds__collapse" aria-label="Country Selector" aria-haspopup="true" aria-expanded="false">
                      <span class="dds__msthd-label dds__text-truncate" style="color: black;">DFM Location: {{preferredFM}}</span>
                    </button>
                    <li class="dds__msthd-offcanvas-tier-1" role="menuitem">
                        <button class="dds__msthd-offcanvas-nav-item dds__collapsed" data-toggle="dds__collapse" aria-expanded="false" (click)="routeToPath('home')" >Home
                        </button>
                    </li>
                    <li class="dds__msthd-offcanvas-tier-1" role="menuitem">
                      <button class="dds__msthd-offcanvas-nav-item dds__collapsed" data-toggle="dds__collapse" aria-expanded="false" (click)="routeToPath('oslang')" >OS Lang
                      </button>
                  </li>
                  <li class="dds__msthd-offcanvas-tier-1" role="menuitem">
                    <button class="dds__msthd-offcanvas-nav-item dds__collapsed" data-toggle="dds__collapse" aria-expanded="false" (click)="routeToPath('transferstatus_v2')" >Transfer Status
                    </button>
                </li>
                <li class="dds__msthd-menu-top-item" role="presentation">
                  <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="3" (click)="routeToPath('userguides')" role="menuitem">User Guides</a>
                </li>
                </ul>
            </aside>
          </div>
          <div *ngIf="!isLoading" class="dds__msthd-top-ctnr dds__btn-dropdown dds__d-none dds__d-lg-block">
            <button class="dds__msthd-icon-ctnr"  aria-label="Country Selector" aria-haspopup="true" aria-expanded="false">
              <span class="dds__msthd-label dds__text-truncate">DFM Location: {{DFMLocation}}</span>
            </button>

          </div>
        </div>
      </div>
    </div>
  </nav>
  <nav *ngIf="!isLoading" class="dds__navbar dds__msthd-navbar-bottom dds__msthd-shadow" aria-label="main menu">
    <div class="dds__msthd-shadow-gradient">
      <div class="dds__msthd-bottom dds__container">
        <ul  class="dds__msthd-menu-top" role="menubar" aria-label="main menu">
          <li  class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="true" tabindex="0"  (click)="routeToPath('home')" >Home</a>
          </li>
          <li  class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="1" (click)="routeToPath('oslang')" role="menuitem">OS Lang</a>
          </li>
          <li class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="2" (click)="routeToPathScroll('home','partattachment')" role="menuitem">Part Attachment</a>
          </li>
          <li class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="3" (click)="routeToPathScroll('home','attachfiles')" role="menuitem">Attach Files</a>
          </li>
          <li class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="3" (click)="routeToPath('transferstatus_v2')" role="menuitem">Transfer Status</a>
          </li>
          <li class="dds__msthd-menu-top-item" role="presentation">
            <a class="dds__msthd-menu-top-link" aria-haspopup="true" aria-expanded="false" tabindex="3" (click)="routeToPath('userguides')" role="menuitem">User Guides</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

</div>
